module.exports = __webpack_public_path__ + "img/icon-broken-gray.1082a26e.svg";